// 国际市场产品详情
<template>
  <Mz-Dialog class="dialog" :title="title" width="3800px" :visible.sync="visible" @handleClose="handleClose">
    <div slot="content" class="flx-bs product">
      <div class="left">
        <ul class="flx-bc box">
          <li class="li1">
            <h3 class="title">自前一活动以来的 GDT 价格指数变化</h3>
            <p class="flx-lc"><span>{{info.compared}}</span><i class="icon" :class="info.compared.indexOf('+')>-1?'icon-up':'icon-down'"></i></p>
          </li>
          <li class="li2">
            <h3 class="title">平均中标价格（美元每公吨）</h3>
            <p class="flx-lc"><span>{{info.average}}</span></p>
          </li>
        </ul>
        <div class="part">
          <div class="head flx-bc">
            <span class="title">{{info.name}} 平均价格</span>
            <div class="btns flx-lc">
              <span :class="year===1?'active':''" @click="year=1">12个月</span>
              <span :class="year===5?'active':''" @click="year=5">5年</span>
            </div>
          </div>
          <div class="chart" id="chart"></div>
        </div>
      </div>
      <div class="right">
        <ul class="flx-lc tabs">
          <li :class="tabId===item.id?'active':''" v-for="item in tabData" :key="item.id" @click="tabId=item.id">{{item.name}}</li>
        </ul>
        <div class="tabContent">
          <table class="mytable" v-if="tabId===1">
            <tr>
              <th :style="tabId==1?{width:'380px'}:tabId==2?{width:'490px'}:{width:'660px'}"></th>
              <th v-for="item in info.times" :key="item.time"><p>{{item.name}}</p><p>{{item.time}}</p></th>
            </tr>
            <tbody v-for="(data,index) in tableData" :key="index">
              <tr>
                <td>{{data.name}}</td>
                <td v-for="(item,index) in data.data" :key="index">{{item}}</td>
              </tr>
            </tbody>
          </table>
          <table class="mytable" v-else>
            <tr>
              <th :style="tabId==1?{width:'380px'}:tabId==2?{width:'490px'}:{width:'660px'}"></th>
              <th v-for="item in info.times" :key="item.time"><p>{{item.name}}</p><p>{{item.time}}</p></th>
            </tr>
            <tbody v-for="(data,index) in tableData" :key="index">
              <tr v-if="data.title">
                <td :colspan="info.times.length+1">{{data.title}}</td>
              </tr>
              <tr v-if="data.subtitle">
                <td :colspan="info.times.length+1">{{data.subtitle}}</td>
              </tr>
              <tr v-for="row in data.data" :key="row.name">
                <td>{{row.name}}</td>
                <td v-for="(item,index) in row.data" :key="index">{{item}}</td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
      <p class="tip">* 数据来源于 GDT</p>
    </div>
  </Mz-Dialog>
</template>

<script>
import echarts from 'echarts'
export default {
  components: {},
  props: {
      visible: {
          type: Boolean,
          default: false
      },
      title: {
          type: String,
          default: ''
      },
      info: {
        type: Object,
        default: {}
      }
  },
  data() {
    return {
      year: 1,
      datas: [],
      tabData: [{id:1,name:'价格指数变化'},{id:2,name:'各地区平均价格（美元/公吨）'},{id:3,name:'单个卖家中标价格（美元/公吨）'}],
      tabId: 1,
      tableData: []
    };
  },
  created(){
    this.datas = this.info.averageData.oneYear
    this.tabData[0].name = this.info.name + this.tabData[0].name
  },
  mounted() {
    this.$nextTick(() => {
      this.echarts()
    })
  },
  watch: {
    year: {
      handler(val){
        if(val===1){
          this.datas = this.info.averageData.oneYear
        }else{
          this.datas = this.info.averageData.fiveYear
        }
        this.echarts()
      }
    },
    tabId: {
      handler(val){
        switch(val){
          case 1:
            this.tableData = this.info.afmData
            break;
          case 2:
            this.tableData = this.info.averageArea
            break;
          case 3:
            this.tableData = this.info.seller
            break;
        }
      },
      immediate: true
    }
  },
  methods: {
    echarts(){
        var chart = echarts.init(document.getElementById('chart'));
        let dataX = this.datas.map(it => {
            return it.time
        })
        let dataY = this.datas.map(it => {
            return it.value
        })
        // 清空图表
        chart.clear();
        chart.setOption({
            // 设置绘图区域的边距
            grid: {
                left: 0,   // 左侧距离
                right: 70,  // 右侧距离
                top: 42,   // 可选：顶部距离
                bottom: 0, // 可选：底部距离
                containLabel: true // 确保标签不被裁剪
            },
            tooltip: {
                trigger: 'axis',
                textStyle: {
                    color: '#fff',
                    fontSize: 36, 
                    fontWeight: 'bold', 
                },
            },
            xAxis: {
                type: 'category',
                data: dataX,
                axisTick: {
                    show: false
                },
                axisLine: {
                    lineStyle: {
                        color: '#2A54A2', // 设置 x 轴线的颜色
                        width: 3
                    }
                },
                boundaryGap: false, // 去掉左右两边的空白
                axisLabel: {
                    color: '#fff', // 文字颜色
                    fontSize: 28,   // 字体大小
                    margin: 26,
                    rotate: 45
                }
            },
            yAxis: {
                type: 'value',
                min: 2000,
                axisLine: {
                    lineStyle: {
                        color: '#2A54A2', // 设置 x 轴线的颜色
                        width: 3
                    }
                },
                splitLine: { 
                  lineStyle: {
                        color: '#2A54A2', // 设置 x 轴线的颜色
                        width: 3,
                        type: 'dashed'
                    }
                },
                axisTick: { show: false },
                axisLabel: {
                    color: '#fff', // 文字颜色
                    fontSize: 30,   // 字体大小
                    margin: 45,
                    formatter(value) {
                      return '$'+ value
                    }
                },
            },
            series: [{
                data: dataY,
                type: 'line',
                smooth: true,
                symbol: 'circle',
                symbolSize: 24,
                showSymbol: true,
                itemStyle: {
                    color: '#061938',
                    borderColor: '#0CFBFF',
                    borderWidth: 3, 
                    borderType: 'solid'
                },
                lineStyle: {
                    color: '#0CFBFF', 
                    width: 3,
                    type: 'solid'
                },
            }]
        })
    },
    handleClose(){
        this.$emit('update:visible', false)
    }
  },
};
</script>
<style lang="less" scoped>
@import '@/styles/product';
</style>